import type Highcharts from "highcharts";

declare module "highcharts" {
  interface Series {
    hasGroupedData?: boolean;
  }
}

// https://github.com/highcharts/highcharts/blob/56f742e80ff9bf3c13b328f5eb49c7336e8d03d2/ts/Core/Series/Series.ts#L1021

// override getPointsCollection to return points instead of data, since data can have null values when called from getSelectedPoints asynchroneously
export default function fixGetPointsCollection(H: typeof Highcharts) {
  H.wrap(H.Series.prototype, "getPointsCollection", function (this: Highcharts.Series) {
    return (this.hasGroupedData || this.data.some(d => d === null) ? this.points : this.data) || [];
  });
}
